import ArrowUpDownIcon from '@src/components/icons/ArrowUpDown'

interface IToggleExchangeTokensProps {
    onToggleExchangeTokens: () => void
}

export function ToggleExchangeTokens({ onToggleExchangeTokens }: IToggleExchangeTokensProps) {
    return (
        <div className='relative'>
            <div className='absolute left-1/2 flex h-[34px] w-[34px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#0F1011]'>
                <div
                    className='flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-[#16171A]'
                    onClick={onToggleExchangeTokens}
                >
                    <ArrowUpDownIcon />
                </div>
            </div>
        </div>
    )
}
